var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13,3 L13,4 L12,4 L12,13 C12,14.1045695 11.1045695,15 10,15 L5,15 C3.8954305,15 3,14.1045695 3,13 L3,4 L2,4 L2,3 C2,2.44771525 2.44771525,2 3,2 L5,2 C5,1.44771525 5.44771525,1 6,1 L9,1 C9.55228475,1 10,1.44771525 10,2 L12,2 C12.5522847,2 13,2.44771525 13,3 Z M5,4 L5,12 C5,12.5522847 5.44771525,13 6,13 L9,13 C9.55228475,13 10,12.5522847 10,12 L10,4 L5,4 Z M7,12 L8,12 L7,12 Z M6,5 L7,5 L7,12 L6,12 L6,5 Z M8,5 L9,5 L9,12 L8,12 L8,5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5c91163a5c8e4b0dede910c64f161eb6.svg";
export { ForwardRef as ReactComponent };